// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */svg[data-v-f0cc60d4]{display:inline-block;vertical-align:baseline;margin-bottom:-2px;transition:fill .3s,stroke .3s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
